import "./EditedFeatures.css";

import { FeatureWithChanges } from "../../../utils/newVersioningUtils";
import EditedFeaturePanelForOperativeCompare from "./EditedFeaturePanelForOperativeCompare";
import Loader from "../../genericComponents/Loader/Loader";
import { JobsStatus } from "../../../constants/Jobs";
import type { ResourceHandle } from "@arcgis/core/core/Handles";

interface EditedFeaturesForOperativeCompareProps {
    featuresAddedToJob: FeatureWithChanges[];
    isLoadingChanges: boolean;
    storeHighlightHandle: (handle: ResourceHandle | null) => void;
    clearHighlightedFeatures: () => void;
    jobStatus: JobsStatus;
}

const EditedFeaturesForOperativeCompare = (props: EditedFeaturesForOperativeCompareProps) => {
    const renderEditedFeatures = () => {
        const changeList: React.JSX.Element[] = [];
        for (let featureWithChange of props.featuresAddedToJob) {
            changeList.push(
                <EditedFeaturePanelForOperativeCompare
                    key={`${featureWithChange.mainFeature.layerId}-${featureWithChange.mainFeature.objectId}`}
                    editedFeature={featureWithChange}
                    storeHighlightHandle={props.storeHighlightHandle}
                    clearHighlightedFeatures={props.clearHighlightedFeatures}
                    jobStatus={props.jobStatus}
                />
            );
        }

        if (changeList.length === 0 && !props.isLoadingChanges) {
            return <div className="edited-features-no-changes">Ingen endringer funnet</div>;
        }

        return changeList;
    };

    return (
        <div className="edited-features w-100">
            <span className="text-center">Objekter knyttet til jobben:</span>
            {props.isLoadingChanges && (
                <>
                    <br />
                    <Loader inline size={48} />
                </>
            )}
            <div className="edited-features-body">
                <div className="edited-features-content w-100 small-gap">{renderEditedFeatures()}</div>
            </div>
        </div>
    );
};

export default EditedFeaturesForOperativeCompare;
